import {
  Collapse,
  Heading,
  HStack,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useDisclosure,
} from "@chakra-ui/react";
import { ScenarioModel } from "../../clients/KompasApi";
import { tempCalculateCO2Impact as calculateFacadeCO2Impact } from "../../components/EnergyMeasureTable/FacadeMeasuresSubTable";
import { tempCalculateCO2Impact as calculateFloorCO2Impact } from "../../components/EnergyMeasureTable/FloorMeasuresSubTable";
import { tempCalculateCO2Impact as calculateFrameCO2Impact } from "../../components/EnergyMeasureTable/FrameMeasuresSubTable";
import { tempCalculateCO2Impact as calculateHeatingCO2Impact } from "../../components/EnergyMeasureTable/HeatingMeasuresSubTable";
import { tempCalculateCO2Impact as calculateRoofInsulationCO2Impact } from "../../components/EnergyMeasureTable/RoofInsulationMeasuresSubTable";
import { tempCalculateCO2Impact as calculateVentilationCO2Impact } from "../../components/EnergyMeasureTable/VentilationMeasuresSubTable";
import { useAtom } from "jotai";
import { showCO2Atom } from "../modals/ConfigureCompareViewModal";
import { ExpandChevron } from "../../elements/ExpandChevron";
import { FixedNumberDisplay } from "../../elements/NumberDisplay";
import { useComparePageContext } from "../../shared/state/ComparePageContext";

const calculateTotalCO2Impact = (scenario: ScenarioModel) =>
  calculateFacadeCO2Impact(scenario) +
  calculateFrameCO2Impact(scenario) +
  calculateFloorCO2Impact(scenario) +
  calculateRoofInsulationCO2Impact(scenario) +
  calculateVentilationCO2Impact(scenario) +
  calculateHeatingCO2Impact(scenario);

export function CompareTotalCO2ImpactTable() {
  const { scenarios } = useComparePageContext();
  const { isOpen, onToggle } = useDisclosure({ defaultIsOpen: true });
  const [showCO2Impact] = useAtom(showCO2Atom);

  if (!showCO2Impact) return null;

  return (
    <>
      <Heading
        cursor="pointer"
        mb={isOpen ? 0 : 4}
        ml={6}
        onClick={onToggle}
        size="xs"
        w="max-content"
      >
        <ExpandChevron forHeading isOpen={isOpen} /> CO<sub>2</sub> impact
      </Heading>
      <Collapse in={isOpen}>
        <Table
          className={isOpen ? "open" : "closed"}
          sx={{ borderSpacing: "2rem 0" }}
          variant="compare"
        >
          <Thead>
            <Tr id="section-total-price">
              <Th />
              <Th />
              {scenarios.map((scenario) => (
                <Th
                  key={scenario.id}
                  sx={{
                    bg: "brand.gray.100 !important",
                    color: "black !important",
                    pb: "4 !important",
                    textAlign: "start !important",
                  }}
                >
                  Totale CO<sub>2</sub> impact van materialen
                </Th>
              ))}
            </Tr>
          </Thead>
          <Tbody>
            <Tr className="prevent-hover">
              <Td />
              <Td />
              {scenarios.map((scenario) => (
                <Td key={scenario.id} py="2 !important">
                  <HStack justifyContent="space-between">
                    <Text>Totaal</Text>
                    <Text fontWeight="bold">
                      <FixedNumberDisplay
                        number={calculateTotalCO2Impact(scenario)}
                        suffix="kg"
                      />
                    </Text>
                  </HStack>
                </Td>
              ))}
            </Tr>
          </Tbody>
        </Table>
      </Collapse>
    </>
  );
}
